/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RetryInputs */

const bn_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আবার চেষ্টা করুন`)
};

const de_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

const el_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δοκιμάζω πάλι`)
};

const en_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const es_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever`)
};

const fr_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommencer`)
};

const hi_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुन: प्रयास करें`)
};

const hu_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbálja újra`)
};

const id_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencoba kembali`)
};

const it_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const ja_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リトライ`)
};

const ko_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 해 보다`)
};

const nl_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

const pl_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbować ponownie`)
};

const pt_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const ru_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить попытку`)
};

const sv_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Försöka igen`)
};

const tr_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden dene`)
};

const uk_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторіть спробу`)
};

const vi_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

const zh_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_hant_action_retry = /** @type {(inputs: Action_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Action_RetryInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_retry = /** @type {((inputs?: Action_RetryInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RetryInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_retry(inputs)
	if (locale === "de") return de_action_retry(inputs)
	if (locale === "el") return el_action_retry(inputs)
	if (locale === "en") return en_action_retry(inputs)
	if (locale === "es") return es_action_retry(inputs)
	if (locale === "fr") return fr_action_retry(inputs)
	if (locale === "hi") return hi_action_retry(inputs)
	if (locale === "hu") return hu_action_retry(inputs)
	if (locale === "id") return id_action_retry(inputs)
	if (locale === "it") return it_action_retry(inputs)
	if (locale === "ja") return ja_action_retry(inputs)
	if (locale === "ko") return ko_action_retry(inputs)
	if (locale === "nl") return nl_action_retry(inputs)
	if (locale === "pl") return pl_action_retry(inputs)
	if (locale === "pt") return pt_action_retry(inputs)
	if (locale === "ru") return ru_action_retry(inputs)
	if (locale === "sv") return sv_action_retry(inputs)
	if (locale === "tr") return tr_action_retry(inputs)
	if (locale === "uk") return uk_action_retry(inputs)
	if (locale === "vi") return vi_action_retry(inputs)
	if (locale === "zh") return zh_action_retry(inputs)
	return zh_hant_action_retry(inputs)
});